<template>
    <div class="option-select">
        <div class="option" 
             v-for="(option, index) in options" :key="index"
             :style="{'border': 'solid 2px' + colorsOptions[colors.theme][index], 'color': colorsOptions[colors.theme][index]}"
             @click="checkItem(option, index)">
            <input :type="typeOption" class="input" :class="`input-${typeOption}`">
            <!-- <div class="radio-mark" v-if="typeOption == 'radio'">
                <div class="radio-check"></div>
            </div> -->
            <div class="check-mark" v-if="typeOption == 'check'">
                <img class="image-check" src="../../../../public/img/icons/xis-feedback.png" alt="">
            </div>
            <label class="label" for="input">{{option.text}}</label>
        </div>
    </div>
</template>
<script>
import { Bus } from '../../../event-bus.js'
export default {
    data(){
        return{
            optionSelect : false,
            colors:{},
            colorsOptions : {
                dark: ['#3effb6', '#76cee0', '#f7488a'],
                light:['#26a997', '#5097e6', '#fe2e7e']
            },            
        }
    },
    props : {
        options : {
            type : Array,
            required : true
        },
        typeOption : {
            type : String,
            required : true
        },
        itemName : {
            type : String,
            required : true
        },
        selectMore : {
            type : Boolean,
            default : false
        },
        eventButton : {
            type : String,
            default : 'ableButton'
        },
        indexTrue : {
            type : Number
        },
        pageIndex: {
            type: Number
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        if(this.pageIndex == 4) {
            this.colorsOptions.dark.reverse()
            this.colorsOptions.light.reverse()
        }
    },
    methods: {
        checkItem(option, index){
            let options = document.querySelectorAll('.option')
            let classList = options[index].classList
            this.saveData(index)
            // if(!this.selectMore){
            //     options.forEach(optionItem => {
            //         optionItem.classList.remove(`option-${this.typeOption}`)
            //     })  
            //     classList.add(`option-${this.typeOption}`)
            // }
            // let options = document.querySelectorAll('.option')
            options.forEach(option => {
                option.style.backgroundColor = this.colors.theme == 'dark' ? '#001420' : '#fff'
                option.style.color = this.colors.theme == 'dark' ? '#fff' : '#000'
                option.style.borderColor = this.colors.theme == 'dark' ? '#001420' : '#fff'
            })
            options[index].style.backgroundColor = this.colorsOptions[this.colors.theme][index]
            options[index].style.borderColor = this.colorsOptions[this.colors.theme][index]
            options[index].style.color = this.colors.theme == 'dark' ? '#000' : '#fff'
            
            
            if(this.selectMore){
                if(classList.contains(`option-${this.typeOption}`)){
                    classList.remove(`option-${this.typeOption}`)
                    this.mutationStore(index, 'REMOVE_FEEDBACK_ITEM')
                }else{
                    classList.add(`option-${this.typeOption}`)
                    this.mutationStore(index, 'PUSH_FEEDBACK_ITEM')
                }
                return
            }
            this.toggleForm(index)
            this.dispatchStore(index)
        },
        saveData(index){
            if(this.itemName == 'gift'){
                Bus.$emit('defineGift', index)
            }
            if(this.optionSelect == false){
                Bus.$emit(this.eventButton)
                this.optionSelect = true
            }
        },
        dispatchStore(index){
            this.$store.dispatch('callSetFeedback', {
                itemName : this.itemName,
                itemData : this.options[index].value
            })
        },
        mutationStore(index, commit){
            this.$store.commit(commit, {
                itemName : this.itemName,
                itemData : this.options[index].value
            })
        },
        toggleForm(index){
            if(this.indexTrue && this.indexTrue == index){
                Bus.$emit('showForm')
                Bus.$emit('disableButton')
            }

            if(this.indexTrue && this.indexTrue != index){
                Bus.$emit('hideForm')
                this.saveData(index)
                Bus.$emit('ableButton')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .option-select{
        // padding: 0 0 10px;
        .option{
            width: 90%;
            max-width: 600px;
            // height: 70px;
            background-color: white;
            margin : 10px auto;
            padding: 10px 0;
            display: flex;
            align-items: center;
            border-radius: 15px;
            background: none;
            text-align: center;
            justify-content: center;            
            .input{
                display: none;
            }

            .radio-mark, .check-mark{

                width: 30px;
                height: 30px;
                background-color: #e5e5e5;
                margin: 0 5%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .check-mark{

                .image-check{

                    display: none;
                }
            }

            .radio-mark{

                border-radius: 100%;
            }

            .input-radio{

                border : none;
                height: 20px;
                background-image : linear-gradient(rgb(240,240,240),rgb(224,224,224))
            }

            .label{
                width: 61%;
                font-size: 17px;
                line-height: 17px;
                font-weight: 700;
            }
        }

        .option-radio{

            background-color: #85007c;
            color: white;

            .radio-mark{

                background-color : #6b0063;


                .radio-check{

                    width: 15px;
                    height: 15px;
                    border-radius: 100%;
                    background-color: #3defe4;
                }
            }
        }

        .option-check{

            color: #85007c;

            .check-mark{

                background-color: #85007c;

                .image-check{
                    display: block;
                    height: 20px;
                }
            }
        }
    }
</style>
